async function getSavedWallpapers(page: number, limit: number) {
  const serverURL = process.env.REACT_APP_SERVER_URL;
  const url = `${serverURL}/api/saves?page=${page}&limit=${limit}`;

  const res = await fetch(url, { credentials: "include" });
  const wallpapers = await res.json();

  return wallpapers;
}

export default getSavedWallpapers;
